import { IRootState } from 'types/redux'

export const selectBooking = (state: IRootState) => ({
  status: state.booking.status,
  error: state.booking.error,
})
